// extracted by mini-css-extract-plugin
export default {"tag":"cmW2zt","tagText":"dmrX_2","tagButton":"wcdEYj"};